module.exports = __webpack_public_path__ + "img/temperature.74a547d7.png";